"use client";
import React from "react";
import SectionHeading from "../others/SectionHeading";
import TrailingChartModal from "../modal/TrailingChartModal";
import TrailingReturnsTable from "../others/TrailingReturnsTable";
import { formatDate } from "@/utils/commonFunctions";
import { SchemeReturn } from "@/type/schemeType";
import { useIsMobile } from "@/utils/useIsMobile";
import InformationButton from "@/components/ui/InformationButton";

export default function TrailingReturnSection({ returnData }: { returnData: SchemeReturn }) {
  const isMobile = useIsMobile();

  const tableDataShortTerms = returnData
    ? [
        {
          label: "This Fund",
          values: {
            "1W": `${returnData?.sr_one_weak_abs ?? "-"}`,
            "1M": `${returnData?.sr_one_month_abs ?? "-"}`,
            "3M": `${returnData?.sr_three_month_abs ?? "-"}`,
            "6M": `${returnData?.sr_six_month_abs ?? "-"}`,
            "1Y": `${returnData?.sr_one_year_abs ?? "-"}`,
            "2Y": `${returnData?.sr_two_year ?? "-"}`,
            "3Y": `${returnData?.sr_three_year ?? "-"}`,
            "5Y": `${returnData?.sr_five_year ?? "-"}`,
          },
        },
        {
          label: "Category Average",
          values: {
            "1W": `${returnData?.cr_one_weak_abs ?? "-"}`,
            "1M": `${returnData?.cr_one_month_abs ?? "-"}`,
            "3M": `${returnData?.cr_three_month_abs ?? "-"}`,
            "6M": `${returnData?.cr_six_month_abs ?? "-"}`,
            "1Y": `${returnData?.cr_one_year_abs ?? "-"}`,
            "2Y": `${returnData?.cr_two_year ?? "-"}`,
            "3Y": `${returnData?.cr_three_year ?? "-"}`,
            "5Y": `${returnData?.cr_five_year ?? "-"}`,
          },
        },
        {
          label: "Benchmark Returns",
          values: {
            "1W": `${returnData?.br_one_weak_abs ?? "-"}`,
            "1M": `${returnData?.br_one_month_abs ?? "-"}`,
            "3M": `${returnData?.br_three_month_abs ?? "-"}`,
            "6M": `${returnData?.br_six_month_abs ?? "-"}`,
            "1Y": `${returnData?.br_one_year_abs ?? "-"}`,
            "2Y": `${returnData?.br_two_year ?? "-"}`,
            "3Y": `${returnData?.br_three_year ?? "-"}`,
            "5Y": `${returnData?.br_five_year ?? "-"}`,
          },
        },
      ]
    : [];

  if (!returnData) return;

  return (
    <section className="mb-8 xs:mb-12">
      <div className="flex items-center gap-3 mb-2 sm:mb-4">
        <SectionHeading heading="Trailing Returns" />
        <InformationButton keywords="trailing-returns" />

        {!isMobile && <TrailingChartModal data={returnData} className="hidden sm:flex" />}
        {isMobile && returnData.sr_updated_at && <p className="sm:hidden text-xs text-[#6E6E73] font-medium ml-auto">As of {formatDate(returnData.sr_updated_at || "")}</p>}
      </div>

      <div className="bg-white border border-[#E9E9EB] p-6 rounded-4xl">
        <TrailingReturnsTable data={tableDataShortTerms} switchMode={true} />
      </div>

      {isMobile && <TrailingChartModal data={returnData} className="flex sm:hidden" />}
      {!isMobile && returnData.sr_updated_at && <p className="hidden sm:block text-xs text-[#6E6E73] font-medium mt-2.5">As of {formatDate(returnData.sr_updated_at || "")}</p>}
    </section>
  );
}
